import React from 'react';
import { EnhancedAssumptions } from '../../types';
import { Card } from '../ui';
import { ScenarioSelector } from './ScenarioSelector';
import { SCENARIO_OPTIONS } from '../../constants';

interface PropertyBasicsProps {
  assumptions: EnhancedAssumptions;
  onUpdate: (key: keyof EnhancedAssumptions, value: any) => void;
  onNumberInput: (key: keyof EnhancedAssumptions, value: string) => void;
  onScenarioChange: (type: string, scenario: string) => void;
}

export const PropertyBasics: React.FC<PropertyBasicsProps> = ({
  assumptions,
  onUpdate,
  onNumberInput,
  onScenarioChange
}) => {
  return (
    <Card>
      <h2 className="text-xl font-semibold text-gray-900 mb-6">Property Basics</h2>
      <div className="space-y-4">
        <ScenarioSelector
          label="Property Value"
          scenarioType="propertyValue"
          currentScenario={assumptions.propertyValueScenario}
          currentValue={assumptions.propertyValue}
          scenarioOptions={SCENARIO_OPTIONS.propertyValue}
          onScenarioChange={onScenarioChange}
          onCustomValueChange={onNumberInput}
        />
        
        <ScenarioSelector
          label="Monthly Rent"
          scenarioType="monthlyRent"
          currentScenario={assumptions.monthlyRentScenario}
          currentValue={assumptions.monthlyRent}
          scenarioOptions={SCENARIO_OPTIONS.monthlyRent}
          onScenarioChange={onScenarioChange}
          onCustomValueChange={onNumberInput}
        />
      </div>
    </Card>
  );
};